import React, { ReactNode } from "react";
import { PageWrapper } from "../../../common/layout/PageWrapper";
import { GetCompliantPageContent } from "../../../common/layout/PageContent";
import { OmniBarProvider } from "../../../common/hooks/useOmniBar";
import { OmniBar } from "../dialog/OmniBar";
import { NetworkRequestState } from "../../../common/models";
import { NetworkRequestGate } from "../../../common/components/NetworkRequestGate";

type GetCompliantPageWrapperProps = {
  children: ReactNode;
  header?: ReactNode;
  progressFooter?: ReactNode;
  fullWidth?: boolean;
  disablePadding?: boolean;
  requests?: NetworkRequestState[];
};

export const GetCompliantPageWrapper: React.FC<GetCompliantPageWrapperProps> = ({
  children,
  header,
  progressFooter,
  fullWidth = false,
  disablePadding = false,
  requests = [],
}) => {
  return (
    <PageWrapper cls="get-compliant-wrapper">
      <OmniBarProvider>
        <OmniBar></OmniBar>

        <GetCompliantPageContent
          header={header}
          footer={progressFooter}
          fullWidth={fullWidth}
          disablePadding={disablePadding}
        >
          <NetworkRequestGate requests={requests}>{children}</NetworkRequestGate>
        </GetCompliantPageContent>
      </OmniBarProvider>
    </PageWrapper>
  );
};

GetCompliantPageWrapper.displayName = "GetCompliantPageWrapper";
